<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Orders/Receipt Summary
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="inboundOrder"
      :options.sync="options"
      :server-items-length="total"
      :loading="inboundOrderLoader"
      class="elevation-1 custom-icon-size mr-8"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  @change="fetchClientList(warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @change="getStores()"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0" v-if="selectedClient">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="Receipt key"
                  outlined
                  v-model="receipt_key"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="Storer key"
                  outlined
                  v-model="storer_key"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  label="Status"
                  item-text="text"
                  item-value="value"
                  :items="statusArr"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="asn_status"
                  label="ASN Status"
                  item-text="name"
                  item-value="id"
                  :items="asnstatusArr"
                  outlined
                  @focus="fetchStatus()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                cols="3"
                class="pr-4"
                :sm="
                  (userCategory.user_category == 3 ||
                    userCategory.user_category == 6) &&
                  selectedClient
                    ? 9
                    : 12
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="primary"
                  class="v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary mr-2"
                  @click="sync"
                  :loading="syncButton"
                  style="float: right"
                  v-if="
                    checkPermission('app_infor:inbound_report_summary_sync') &&
                    warehouse_id &&
                    (userCategory.user_category === 3 ||
                      userCategory.user_category === 6)
                  "
                  >Sync</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.client_id__name`]="{ item }"
        >{{ item.client_id__name }}<br />
        ({{ item.storer_key }})
      </template>
      <template v-slot:[`item.created_datetime`]="{ item }">
        <span v-if="item.created_datetime">{{
          item.created_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.updated_datetime`]="{ item }">
        <span v-if="item.updated_datetime">{{
          item.updated_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.last_received_datetime`]="{ item }">
        <span v-if="item.last_received_datetime">{{
          item.last_received_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.last_put_away_datetime`]="{ item }">
        <span v-if="item.last_put_away_datetime">{{
          item.last_put_away_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.first_received_datetime`]="{ item }">
        <span v-if="item.first_received_datetime">{{
          item.first_received_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.first_put_away_datetime`]="{ item }">
        <span v-if="item.first_put_away_datetime">{{
          item.first_put_away_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.asn_closed_datetime`]="{ item }">
        <span v-if="item.asn_closed_datetime">{{
          item.asn_closed_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
        <br />
        <span v-if="item.cancelled_datetime"
          >/
          {{
            item.cancelled_datetime
              | localMomentformat
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
      </template>
      <template v-slot:[`item.asn_created_datetime`]="{ item }">
        <span v-if="item.asn_created_datetime">{{
          item.asn_created_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.arrival_datetime`]="{ item }">
        <span v-if="item.arrival_datetime">{{
          item.arrival_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.shipping_address_country`]="{ item }">
        <label>
          {{ item.shipping_address_country }}
        </label>
      </template>
      <template v-slot:[`item.receipt_key`]="{ item }">
        {{ item.receipt_key }} <br />
        <span v-if="item.external_receipt_key"
          >({{ item.external_receipt_key }})
        </span>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    syncButton: false,
    infor_storer_id: null,
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    receipt_key: null,
    receipt_no: null,
    orderDetails: [],
    statuses: [],
    status: "",
    statusArr: [],
    headers: [
      {
        text: "Storer",
        value: "storer_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 130,
      },
      // {
      //   text: "Warehouse",
      //   value: "warehouse_id__name",
      //   class: "body-1 font-weight-bold",
      //   align: "left",
      //   sortable: false,
      // },
      {
        text: "ASN/Receipt (External Receipt key)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Arrival Date",
        value: "arrival_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "ASN Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "ASN Created At",
        value: "asn_created_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Total Expected Qty",
        value: "total_expected_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "First Received Date",
        value: "first_received_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },

      {
        text: "Last Received Date",
        value: "last_received_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Total Received Time",
        value: "total_received_time",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Total Received Qty",
        value: "total_received_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "First Putaway Date",
        value: "first_put_away_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },

      {
        text: "Last Putaway Date",
        value: "last_put_away_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Total Putaway Time",
        value: "total_putaway_time",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Putaway Pending Qty",
        value: "putaway_pending_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Putaway Pending Lpns",
        value: "putaway_pending_lpns",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Putaway Status",
        value: "putaway_status_message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "ASN Closed / Cancelled Date",
        value: "asn_closed_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },

      {
        text: "Created At",
        value: "created_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_datetime",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
    ],
    inboundOrder: [],
    options: {},
    total: 0,
    warehouse_id: null,

    clients: [],
    selectedClient: null,
    filtersArr: {},
    stores: [],
    warehouses: [],
    storer_key: "",
    inboundOrderLoader: false,
    asnstatusArr: [],
    asn_status: null,
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  created() {
    this.getwarehouse();
    this.fetchStatus();
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getInboundOrderBBSummaryList",
      "fetchClient",
      "getChannelDropdown",
      "getWarehouseStores",
      "getInforWarehouseList",
      "inboundSummarySync",
      "inboundStatus",
    ]),

    getwarehouse() {
      this.storer_key = "";
      this.sku = null;
      this.warehouse_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    fetchStatus() {
      if (this.asnstatusArr.length == 0)
        this.inboundStatus("inbound").then((res) => {
          let statusArr = Object.entries(res.data.data).map(([key, value]) => {
            return { id: key, name: value };
          });
          this.asnstatusArr = statusArr;
        });
    },
    getStores() {
      this.infor_storer_id = null;
      this.sku = null;
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };
      if (this.selectedClient && this.warehouse_id) {
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },

    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        receipt_key: this.receipt_key
          ? this.receipt_key.trim()
          : this.receipt_key,
        start_date: this.from_date,
        end_date: this.to_date,
        storer_id: this.infor_storer_id,
        warehouse_id: this.warehouse_id,
        storer_key: this.storer_key,
        putaway_status: this.status,
        asn_status: this.asn_status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    clearAll() {
      this.receipt_key = "";
      this.selectedClient = "";
      this.receipt_no = "";
      this.status = "";
      this.from_date = null;
      this.to_date = null;
      this.infor_storer_id = null;
      this.storer_key = "";
      this.warehouse_id = null;
      this.clients = [];
      this.stores = [];
      this.asn_status = null;
      this.searchAll();
    },

    fetchClientList() {
      this.client = [];
      this.storer = [];
      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          type: "warehouse",
          warehouse_id: this.warehouse_id,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getlist() {
      this.getInboundOrderBBSummaryList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;
          this.total = res.data.total;
          this.statusArr = Object.entries(res.data.putaway_status).map(
            ([key, value]) => ({
              text: value,
              value: parseInt(key),
            })
          );
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },

    sync() {
      this.syncButton = true;
      let index = this.warehouses.findIndex(
        (item) => item.id == this.warehouse_id
      );
      let payload = {
        warehouse: this.warehouses[index].name,
      };
      this.inboundSummarySync(payload)
        .then((response) => {
          this.syncButton = false;

          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.getlist();
        })
        .catch(() => {
          this.syncButton = false;
        });
    },
    findSummary(id) {
      this.inboundorderSummary(id).then((res) => {
        this.orderDetails = res.data.data.items;
        this.summary = true;
      });
    },
    tracking(id) {
      this.orderTracking(id).then((res) => {
        this.trackingDetails = res.data.data.records;
        this.reverseData = res.data.data.event_history;
        this.trackingPage = true;
      });
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getInboundOrderBBSummaryList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;

          this.total = res.data.total;
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },
    gotodetails(item) {
      window.open(
        this.$router.resolve({
          name: "InboundSummary",
          query: {
            key: item.id,
            id: item.client_id,
          },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 3px 5px 5px !important;
}
</style>
